/* ------------------------------------------------------------------------- *
   <pinzelli-bundle> — sélecteur de packs Pinzelli.
   Vanilla, sans dépendance. Reprend la logique du bundle d'origine :
   choix d'une offre, composition des couleurs avec compteur + limite,
   prix unitaire, puis ajout au panier via /cart/add.js.
 * ------------------------------------------------------------------------- */
(function () {
  if (customElements.get('pinzelli-bundle')) return;

  function shade(hex, amount) {
    if (!hex || hex.charAt(0) !== '#' || hex.length < 7) hex = '#cccccc';
    var n = parseInt(hex.slice(1, 7), 16);
    var clamp = function (v) {
      return Math.max(0, Math.min(255, v));
    };
    var r = clamp((n >> 16) + amount);
    var g = clamp(((n >> 8) & 255) + amount);
    var b = clamp((n & 255) + amount);
    return '#' + (0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1);
  }

  function pinSvg(hex) {
    var gid = 'pzb' + Math.random().toString(36).slice(2, 8);
    var lite = shade(hex, 34);
    var dark = shade(hex, -34);
    var edge = shade(hex, -50);
    return (
      '<svg viewBox="0 0 100 150" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="' + lite + '"/>' +
      '<stop offset=".55" stop-color="' + hex + '"/>' +
      '<stop offset="1" stop-color="' + dark + '"/></linearGradient></defs>' +
      '<path d="M33 130 L33 50 C33 28 67 28 67 50 L67 130" fill="none" stroke="' + edge + '" stroke-width="19" stroke-linecap="round"/>' +
      '<path d="M33 130 L33 50 C33 28 67 28 67 50 L67 130" fill="none" stroke="url(#' + gid + ')" stroke-width="15.5" stroke-linecap="round"/>' +
      '<circle cx="50" cy="39" r="4.6" fill="#c9a24a"/></svg>'
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function template(str, data) {
    return String(str || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(data, key) ? data[key] : match;
    });
  }

  class PinzelliBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.offers = Array.prototype.slice.call(this.querySelectorAll('[data-pzb-offer]'));
      this.grid = this.querySelector('[data-pzb-grid]');
      this.countEl = this.querySelector('[data-pzb-count]');
      this.barEl = this.querySelector('[data-pzb-bar]');
      this.dotsEl = this.querySelector('[data-pzb-dots]');
      this.summaryEl = this.querySelector('[data-pzb-summary]');
      this.giftEl = this.querySelector('[data-pzb-gift]');
      this.ctaEl = this.querySelector('[data-pzb-cta]');
      this.errorEl = this.querySelector('[data-pzb-error]');

      this.colors = this.readColors();
      this.quantities = {};
      this.busy = false;

      this.allowDuplicates = this.dataset.allowDuplicates !== 'false';
      this.maxPerColor = parseInt(this.dataset.maxPerColor || '0', 10) || 0;
      this.after = this.dataset.after || 'drawer';
      this.propertyName = this.dataset.propertyName || 'Composition';
      this.giftId = (this.dataset.giftVariant || '').trim();
      this.giftQuantity = parseInt(this.dataset.giftQuantity || '1', 10) || 1;
      this.giftMin = parseInt(this.dataset.giftMin || '0', 10) || 0;
      this.giftLabel = this.dataset.giftLabel || '';

      this.labels = {
        ready: this.dataset.ctaReady || 'Ajouter au panier',
        missing: this.dataset.ctaMissing || 'Encore {count} article{plural}',
        loading: this.dataset.ctaLoading || 'Ajout…',
        done: this.dataset.ctaDone || 'Ajouté ✓',
        error: this.dataset.ctaError || 'Une erreur est survenue — réessayez.',
        add: this.dataset.addLabel || '+ Ajouter',
        remove: this.dataset.removeLabel || 'Retirer',
        soldOut: this.dataset.soldOutLabel || 'Épuisé'
      };

      this.selectedIndex = Math.max(
        0,
        this.offers.findIndex(function (offer) {
          return offer.classList.contains('is-selected');
        })
      );

      this.offers.forEach(
        function (offer, index) {
          offer.addEventListener(
            'click',
            function () {
              this.selectOffer(index);
            }.bind(this)
          );
        }.bind(this)
      );

      if (this.grid) {
        this.grid.addEventListener('click', this.onGridClick.bind(this));
      }
      if (this.ctaEl) {
        this.ctaEl.addEventListener('click', this.addToCart.bind(this));
      }

      /* Passerelle gamme métal : on mesure le clic sans retarder la navigation.
         Aucun outil analytics n'est chargé par le thème, on pousse donc dans
         dataLayer — GTM le récupère s'il est présent, sinon l'objet reste inerte. */
      var metalLink = this.querySelector('[data-pzb-metal]');
      if (metalLink) {
        metalLink.addEventListener(
          'click',
          function () {
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'bundle_metal_upsell_click',
                destination: metalLink.getAttribute('data-metal-destination') || '',
                pack_selected: (function (o) {
                  if (!o) return '';
                  var n = o.querySelector('.pzb__offer-name');
                  return n ? n.textContent.trim() : '';
                })(this.offer),
                source: 'pdp_bundle'
              });
            } catch (e) {}
          }.bind(this)
        );
      }

      if (this.offers.length) this.classList.add('is-revealed');
      this.applyOffer();
      this.render(false);
    }

    readColors() {
      var node = this.querySelector('[data-pzb-colors]');
      if (!node) return [];
      try {
        var parsed = JSON.parse(node.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.warn('[pinzelli-bundle] liste de couleurs illisible', error);
        return [];
      }
    }

    get offer() {
      return this.offers[this.selectedIndex] || null;
    }

    packSize() {
      var offer = this.offer;
      var size = offer ? parseInt(offer.dataset.quantity, 10) : 0;
      return size > 0 ? size : 1;
    }

    total() {
      var sum = 0;
      for (var key in this.quantities) {
        if (Object.prototype.hasOwnProperty.call(this.quantities, key)) sum += this.quantities[key];
      }
      return sum;
    }

    selectOffer(index) {
      if (index === this.selectedIndex) return;
      this.selectedIndex = index;
      this.classList.add('is-revealed');
      this.trimToPackSize();
      this.applyOffer();
      this.render(false);
    }

    /* Réduit la sélection quand on passe sur une offre plus petite. */
    trimToPackSize() {
      var max = this.packSize();
      var keys = Object.keys(this.quantities);
      var index = keys.length - 1;
      while (this.total() > max && index >= 0) {
        var key = keys[index];
        this.quantities[key] -= 1;
        if (this.quantities[key] <= 0) {
          delete this.quantities[key];
          index -= 1;
        }
      }
    }

    /* Répercute le prix du pack choisi sur l'encart titre/prix au-dessus.
       Sans ça l'encart continue d'afficher le prix unitaire alors qu'on achète un lot. */
    syncCardPrice(offer) {
      if (this.dataset.syncCardPrice === 'false') return;
      var scope = this.closest('[id^="ProductInfo-"]') || document;
      var priceEl = scope.querySelector('.pic-price');
      if (!priceEl) return;

      if (!this.basePrice) {
        this.basePrice = priceEl.innerHTML;
        var c0 = scope.querySelector('.pic-compare');
        this.baseCompare = c0 ? c0.innerHTML : null;
      }

      var compareEl = scope.querySelector('.pic-compare');
      if (offer && offer.dataset.price) {
        priceEl.innerHTML = offer.dataset.price;
        if (offer.dataset.compare) {
          if (compareEl) {
            compareEl.innerHTML = offer.dataset.compare;
            compareEl.hidden = false;
          }
        } else if (compareEl) {
          compareEl.hidden = true;
        }
      } else {
        priceEl.innerHTML = this.basePrice;
        if (compareEl) {
          compareEl.hidden = false;
          if (this.baseCompare !== null) compareEl.innerHTML = this.baseCompare;
        }
      }
    }

    applyOffer() {
      this.offers.forEach(
        function (offer, index) {
          var selected = index === this.selectedIndex;
          offer.classList.toggle('is-selected', selected);
          offer.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }.bind(this)
      );

      var offer = this.offer;
      if (this.summaryEl) {
        if (offer) {
          var bits = [];
          if (offer.dataset.label) bits.push('<b>' + escapeHtml(offer.dataset.label) + '</b>');
          if (offer.dataset.perUnit) bits.push(escapeHtml(offer.dataset.perUnit));
          var line = bits.join(' · ');
          if (offer.dataset.save) {
            line += ' <span class="pzb__summary-save">' + escapeHtml(offer.dataset.save) + '</span>';
          }
          this.summaryEl.innerHTML = line;
        } else {
          this.summaryEl.innerHTML = '';
        }
      }

      this.syncCardPrice(offer);

      if (this.giftEl) {
        var eligible = !!this.giftId || this.giftEl.dataset.pzbGiftDisplayOnly === 'true';
        this.giftEl.hidden = !eligible || this.packSize() < this.giftMin;
      }
    }

    canAdd(index) {
      var color = this.colors[index];
      if (!color || color.available === false) return false;
      if (this.total() >= this.packSize()) return false;
      var current = this.quantities[index] || 0;
      if (!this.allowDuplicates && current >= 1) return false;
      if (this.maxPerColor > 0 && current >= this.maxPerColor) return false;
      return true;
    }

    addOne(index) {
      if (!this.canAdd(index)) return;
      this.quantities[index] = (this.quantities[index] || 0) + 1;
      this.render(true);
    }

    removeOne(index) {
      if (!this.quantities[index]) return;
      this.quantities[index] -= 1;
      if (this.quantities[index] <= 0) delete this.quantities[index];
      this.render(false);
    }

    onGridClick(event) {
      var plus = event.target.closest('[data-pzb-plus]');
      if (plus) {
        event.preventDefault();
        this.addOne(parseInt(plus.dataset.pzbPlus, 10));
        return;
      }
      var zoom = event.target.closest('[data-pzb-zoom]');
      if (zoom) {
        event.preventDefault();
        this.openZoom(parseInt(zoom.dataset.pzbZoom, 10));
        return;
      }
      var minus = event.target.closest('[data-pzb-minus]');
      if (minus) {
        event.preventDefault();
        this.removeOne(parseInt(minus.dataset.pzbMinus, 10));
      }
    }

    renderGrid() {
      if (!this.grid) return;
      var full = this.total() >= this.packSize();
      var html = this.colors
        .map(
          function (color, index) {
            var quantity = this.quantities[index] || 0;
            var soldOut = color.available === false;
            var dimmed = !soldOut && full && quantity === 0;
            var visual = color.img
              ? '<img src="' + escapeHtml(color.img) + '" alt="" loading="lazy" width="120" height="140">'
              : pinSvg(color.hex || '#cccccc');
            var control;
            if (soldOut) {
              control = '<button type="button" class="pzb__add" disabled>' + escapeHtml(this.labels.soldOut) + '</button>';
            } else if (quantity > 0) {
              control =
                '<div class="pzb__step">' +
                '<button type="button" class="pzb__step-btn" data-pzb-minus="' + index + '" aria-label="' + escapeHtml(this.labels.remove) + ' ' + escapeHtml(color.name) + '">&minus;</button>' +
                '<span class="pzb__step-value">' + quantity + '</span>' +
                '<button type="button" class="pzb__step-btn" data-pzb-plus="' + index + '"' + (full ? ' disabled' : '') + ' aria-label="' + escapeHtml(this.labels.add) + ' ' + escapeHtml(color.name) + '">+</button>' +
                '</div>';
            } else {
              control =
                '<button type="button" class="pzb__add" data-pzb-plus="' + index + '"' + (dimmed ? ' disabled' : '') + '>' +
                escapeHtml(this.labels.add) +
                '</button>';
            }
            return (
              '<div class="pzb__tile' +
              (quantity > 0 ? ' is-picked' : '') +
              (dimmed ? ' is-dimmed' : '') +
              (soldOut ? ' is-soldout' : '') +
              '">' +
              (quantity > 0 ? '<span class="pzb__badge">' + quantity + '</span>' : '') +
              '<button type="button" class="pzb__visual' + (color.img ? '' : ' pzb__visual--pin') +
              '" data-pzb-zoom="' + index + '" aria-label="' + escapeHtml(color.name) + '">' + visual + '</button>' +
              '<span class="pzb__name">' + escapeHtml(color.name) + '</span>' +
              control +
              '</div>'
            );
          }.bind(this)
        )
        .join('');
      this.grid.innerHTML = html;
    }

    openZoom(index) {
      var color = this.colors[index];
      if (!color) return;
      if (!this.zoomEl) {
        var el = document.createElement('div');
        el.className = 'pzb__zoom';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.innerHTML =
          '<button type="button" class="pzb__zoom-close" aria-label="Fermer">&times;</button>' +
          '<figure class="pzb__zoom-figure"><span class="pzb__zoom-media"></span>' +
          '<figcaption class="pzb__zoom-name"></figcaption></figure>';
        el.addEventListener('click', function (e) {
          if (e.target === el || e.target.closest('.pzb__zoom-close')) this.closeZoom();
        }.bind(this));
        this.appendChild(el);
        this.zoomEl = el;
        this.onZoomKey = function (e) { if (e.key === 'Escape') this.closeZoom(); }.bind(this);
      }
      var media = this.zoomEl.querySelector('.pzb__zoom-media');
      media.innerHTML = color.img
        ? '<img src="' + escapeHtml(color.img) + '" alt="' + escapeHtml(color.name) + '">'
        : pinSvg(color.hex || '#cccccc');
      this.zoomEl.querySelector('.pzb__zoom-name').textContent = color.name;
      this.zoomEl.classList.add('is-open');
      document.addEventListener('keydown', this.onZoomKey);
      var close = this.zoomEl.querySelector('.pzb__zoom-close');
      if (close) close.focus();
    }

    closeZoom() {
      if (!this.zoomEl) return;
      this.zoomEl.classList.remove('is-open');
      document.removeEventListener('keydown', this.onZoomKey);
    }

    renderDots() {
      if (!this.dotsEl) return;
      var html = '';
      this.colors.forEach(
        function (color, index) {
          for (var i = 0; i < (this.quantities[index] || 0); i += 1) {
            html += '<span class="pzb__dot" style="background:' + escapeHtml(color.hex || '#cccccc') + '"></span>';
          }
        }.bind(this)
      );
      var empty = this.packSize() - this.total();
      for (var i = 0; i < empty; i += 1) html += '<span class="pzb__dot pzb__dot--empty"></span>';
      this.dotsEl.innerHTML = html;
    }

    render(bump) {
      var total = this.total();
      var max = this.packSize();

      if (this.countEl) {
        this.countEl.textContent = total + ' / ' + max;
        if (bump) {
          this.countEl.classList.add('is-bumped');
          setTimeout(
            function () {
              this.countEl.classList.remove('is-bumped');
            }.bind(this),
            200
          );
        }
      }
      if (this.barEl) {
        this.barEl.style.width = (max ? Math.min(100, (total / max) * 100) : 0) + '%';
      }

      this.renderDots();
      this.renderGrid();
      this.updateCta(total, max);
    }

    updateCta(total, max) {
      if (!this.ctaEl || this.busy) return;
      var offer = this.offer;
      if (total >= max && total > 0) {
        this.ctaEl.disabled = false;
        this.ctaEl.textContent =
          this.labels.ready + (offer && offer.dataset.price ? ' — ' + offer.dataset.price : '');
      } else {
        this.ctaEl.disabled = true;
        var remaining = max - total;
        this.ctaEl.textContent = template(this.labels.missing, {
          count: remaining,
          plural: remaining > 1 ? 's' : ''
        });
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
    }

    buildItems() {
      var offer = this.offer;
      var properties = {};
      properties[this.propertyName] = offer ? offer.dataset.label || '' : '';
      properties._pzb_pack = 'pzb-' + Date.now();

      var items = [];
      if (offer && offer.dataset.packId) {
        items.push({
          id: Number(offer.dataset.packId),
          quantity: 1,
          properties: Object.assign({}, properties)
        });
      }
      this.colors.forEach(
        function (color, index) {
          var quantity = this.quantities[index] || 0;
          if (quantity > 0 && color.id) {
            items.push({
              id: Number(color.id),
              quantity: quantity,
              properties: Object.assign({}, properties)
            });
          }
        }.bind(this)
      );
      if (this.giftId && this.packSize() >= this.giftMin) {
        var giftProps = Object.assign({}, properties);
        if (this.giftLabel) giftProps[this.giftLabel] = '✓';
        items.push({ id: Number(this.giftId), quantity: this.giftQuantity, properties: giftProps });
      }
      return items;
    }

    addToCart() {
      if (!this.ctaEl || this.ctaEl.disabled || this.busy) return;
      var items = this.buildItems();
      if (!items.length) {
        this.showError(this.labels.error);
        return;
      }

      this.showError('');
      this.busy = true;
      this.ctaEl.disabled = true;
      this.ctaEl.textContent = this.labels.loading;

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (this.after === 'drawer' && cart && typeof cart.getSectionsToRender === 'function') {
        var sections = cart.getSectionsToRender().map(function (section) {
          return section.section;
        });
        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }
      }

      var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(
          function (data) {
            this.busy = false;
            if (this.after === 'cart') {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            if (this.after === 'drawer' && cart && typeof cart.renderContents === 'function' && data.sections) {
              cart.renderContents(data);
            }
            if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
            document.dispatchEvent(new CustomEvent('pinzelli:bundle:added', { bubbles: true, detail: data }));

            this.ctaEl.textContent = this.labels.done;
            this.quantities = {};
            setTimeout(
              function () {
                this.render(false);
              }.bind(this),
              1200
            );
          }.bind(this)
        )
        .catch(
          function (error) {
            this.busy = false;
            var message = (error && (error.description || error.message)) || this.labels.error;
            this.showError(message);
            this.render(false);
          }.bind(this)
        );
    }
  }

  customElements.define('pinzelli-bundle', PinzelliBundle);
})();
